import { createFileRoute } from "@tanstack/react-router";
import { ConceptLanding } from "@/components/site/ConceptLanding";
export const Route = createFileRoute("/vinterevent")({
  head: () => ({
    meta: [
      { title: "Vinterevent, kickoff & mässor | Event Sverige" },
      {
        name: "description",
        content:
          "Planera vinterns företagsevent, mässa eller kickoff. Varm stämning, sociala spel och ett tydligt upplägg med stämningsljus. Skicka en kostnadsfri förfrågan.",
      },
    ],
    links: [{ rel: "canonical", href: "https://eventsverige.se/vinterevent" }],
  }),
  component: () => <ConceptLanding campaign />,
});
